import {ROLES} from "./ROLES";

export function restrictionsForFBTools(state, role): boolean {
  if (role !== ROLES.ADMIN) {
    return state.state === 'Готов' || state.state === 'Проверка закончена' || state.state === 'Relogin выполнен'
  } else {
    return true;
  }
}
